import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Link from "@/components/Link";
import { axios } from "@/services/axios";
import { urlForDashboard } from "@/services/dashboard";

export default function QueryLinkedDashboards({ queryId }) {
  const [loading, setLoading] = useState(true);
  const [dashboards, setDashboards] = useState([]);

  useEffect(() => {
    if (!queryId) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    axios
      .get(`api/queries/${queryId}/dashboards`)
      .then(data => {
        if (!cancelled) {
          setDashboards(data.dashboards || []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setDashboards([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [queryId]);

  if (!queryId) {
    return null;
  }

  return (
    <div className="query-metadata-item query-linked-dashboards">
      <div className="query-metadata-property query-linked-dashboards-inner">
        <span className="query-metadata-label">
          <span className="zmdi zmdi-view-dashboard m-r-5" aria-hidden="true" />
          Dashboards
        </span>
        <span className="query-metadata-value query-linked-dashboards-value">
          {loading && <span className="text-muted">Loading…</span>}
          {!loading && dashboards.length === 0 && <span className="text-muted">None</span>}
          {!loading &&
            dashboards.length > 0 &&
            dashboards.map((d, index) => (
              <React.Fragment key={d.id}>
                {index > 0 && <span className="query-linked-dashboards-sep">, </span>}
                <Link href={urlForDashboard(d)} title={d.name}>
                  {d.name}
                </Link>
              </React.Fragment>
            ))}
        </span>
      </div>
    </div>
  );
}

QueryLinkedDashboards.propTypes = {
  queryId: PropTypes.number,
};

QueryLinkedDashboards.defaultProps = {
  queryId: undefined,
};
